import CatCalculator from "../../components/catCalculatorComponents";

const CatHome = () => {
  return <CatCalculator />;
};
export default CatHome;
